import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ConfigProvider, App, theme } from 'antd'
import { useState } from 'react'

export default function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  }))

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorPrimary: '#06b6d4',
            colorBgBase: '#0B0F19',
            colorBgContainer: '#111827',
            colorBgElevated: '#1a2332',
            colorBgLayout: '#0B0F19',
            colorBorder: '#1e3a5f',
            colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
            colorText: '#e2e8f0',
            colorTextSecondary: '#94a3b8',
            colorTextTertiary: '#64748b',
            borderRadius: 8,
          },
          components: {
            Card: {
              colorBgContainer: '#111827',
              colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
            },
            Table: {
              colorBgContainer: '#111827',
              headerBg: '#1a2332',
              rowHoverBg: '#1a2332',
              borderColor: 'rgba(255, 255, 255, 0.1)',
            },
            Select: {
              colorBgContainer: '#111827',
              colorBgElevated: '#1a2332',
              optionSelectedBg: '#1e3a5f',
            },
            Input: {
              colorBgContainer: '#111827',
              colorBorder: 'rgba(255, 255, 255, 0.1)',
            },
            DatePicker: {
              colorBgContainer: '#111827',
              colorBgElevated: '#1a2332',
            },
            Modal: {
              contentBg: '#111827',
              headerBg: '#111827',
            },
            Menu: {
              colorBgContainer: '#0F1422',
              colorItemBgSelected: '#1e3a5f',
              colorItemTextSelected: '#06b6d4',
            },
            Button: {
              colorBgContainer: '#111827',
            },
            Statistic: {
              colorTextDescription: '#94a3b8',
            },
            Descriptions: {
              colorBgContainer: '#111827',
              labelBg: '#1a2332',
            },
            Alert: {
              colorInfoBg: '#1a2332',
              colorWarningBg: '#1a2332',
              colorErrorBg: '#1a2332',
              colorSuccessBg: '#1a2332',
            },
            List: {
              colorBgContainer: '#111827',
            },
            Form: {
              labelColor: '#e2e8f0',
            },
            Pagination: {
              colorBgContainer: '#111827',
              colorBgTextHover: '#1a2332',
            },
          },
        }}
      >
        <App>
          {children}
          <ReactQueryDevtools initialIsOpen={false} />
        </App>
      </ConfigProvider>
    </QueryClientProvider>
  )
}